import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
  margin: 2rem 0;
  > .MuiAutocomplete-root,
  > .MuiFormControl-root {
    width: 100%;
    max-width: 200px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    > button {
      height: fit-content;
      padding: 0.2rem 0.8rem;
      margin: 0.6rem 0 0 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;

    > .MuiFormControl-root {
      width: 100%;
      max-width: 100%;
    }

    > button {
      width: 100%;
      max-width: 100%;
    }
  }
`;
